import { render, staticRenderFns } from "./luckyDraw.vue?vue&type=template&id=23b0e4c0&scoped=true&"
import script from "./luckyDraw.vue?vue&type=script&lang=js&"
export * from "./luckyDraw.vue?vue&type=script&lang=js&"
import style0 from "./luckyDraw.vue?vue&type=style&index=0&id=23b0e4c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b0e4c0",
  null
  
)

export default component.exports